import { Skeleton } from '@mui/material';
import { ITableColumn } from '@/components/UI/DataTable/TableHead';

interface SkeletonRowProps {
  columns: ITableColumn<any>[];
}

export default function Component({ columns }: SkeletonRowProps){
  return (
     <>
      {columns.map((column) => (
          <Skeleton key={String(column.id)} variant="text" width="100%" height={15} sx={{margin:"10px"}} />
      ))}
     </>
  );
};